<template>
  <div class="content-wrapper">
    <div class="content-lookup">
      <div class="lookup-left">
        <ul class="lookup-condition">
          <li class="field">
            <div class="title">사용자</div>
            <ul class="content">
              <li class="item">
                <input-text
                    v-model="search.userName"
                    placeholder="내용을 입력하세요."
                />
              </li>
            </ul>
          </li>
          <li class="field">
            <div class="title">변경 일자</div>
            <ul class="content">
              <li class="item dateRange">
                <input-date-range
                    type="lookup-condition"
                    v-model="search.dateRange"
                />
              </li>
            </ul>
          </li>


        </ul>
        <div class="lookup-lookup">
          <erp-button
              button-div="GET"
              :is-shortcut-button="true"
              @click.native="fetchHomePagePasswordChangeHist"
          >
            조회
          </erp-button>
        </div>
      </div>
    </div>

    <div class="content-body">
      <report-view
          ref="reportViewComponent"
          :isPopup="true"
      />
      <article class="body-article">
        <!-- 아코디언 : accordion / 닫힘 : close -->
        <section class="article-section section-01">
          <div class="section-header">
            <div class="header-left">
              <div class="header-title">홈페이지 비밀번호 변경 이력</div>
              <div class="header-caption">[{{ count }}건]</div>
            </div>
            <div class="header-right">
              <ul class="header-button">
                <li class="print">
                  <erp-button
                      button-div="PRINT"
                      :is-shortcut-button="true"
                      @click.native="onPrintClick"
                  >
                    인쇄
                  </erp-button>
                </li>
                <li class="print">
                  <erp-button
                      button-div="FILE"
                      @click.native="onExcelClick"
                  >
                    Excel
                  </erp-button>
                </li>
              </ul>
            </div>
          </div>
          <div class="section-body">
            <div class="body-grid">
              <ejs-grid-wrapper
                  ref="grid"
                  :allowEditing="false"
                  :allowExcelExport="true"
                  :allowPaging="true"
                  :allowResizing="true"
                  :provides="grid"
                  :pageSettings="pageSettings"
                  :columns="columns"
                  :data-source="content.HomePagePasswordChangeHist"
                  @actionComplete="gridComplete"

              />
            </div>
          </div>
        </section>
      </article>
    </div>
  </div>

</template>

<script>
import moment from "moment";
import ReportView from "../../components/common/report/ReportView.vue";
import ejsGridWrapper from "../../components/common/EjsGridWrapper.vue";
import InputText from "../../components/common/text/InputText.vue";
import inputDateRange  from "../../components/common/datetime/InputDateRange.vue";
import commonMixin from "../../views/layout/mixin/commonMixin";
import GolfErpAPI from "../../api/v2/GolfErpAPI";
import messagePopupDialogMixin from "@/views/layout/mixin/messagePopupDialogMixin";
import {ExcelExport, ForeignKey, Page, Resize} from "@syncfusion/ej2-vue-grids";
import { numberWithCommas } from "@/utils/number";
import ErpButton from "@/components/button/ErpButton.vue";

export default {
  name: "HomePagePasswordChangeHist",
  mixins: [commonMixin, messagePopupDialogMixin],
  props: {

  },
  components: {
    ReportView
    ,ejsGridWrapper
    ,inputDateRange
    ,InputText
    ,ErpButton
  },
  created() {
  },
  mounted() {
  },
  computed: {
  },
  data () {
    return {
      count: 0,
      isAddPrintPopupOpen: false,
      search: {
        userName: '',
        dateRange: {
          from: moment().startOf('month').format('YYYY-MM-DD'),
          to: moment().format('YYYY-MM-DD'),
        },
      },
      content: {
        HomePagePasswordChangeHist: []
      },
      grid: [
        Resize,
        Page,
        ExcelExport,
        ForeignKey,
      ],
      columns: [
        {
          field: 'logId',
          visible: false,
          type: 'number',
        },
        {
          field: 'userName',
          headerText: '사용자명',
          textAlign: 'center',
          width: 100,
          type: 'string',
        },
        {
          field: 'webId',
          headerText: '웹ID',
          textAlign: 'center',
          width: 100,
          type: 'string',
        },
        {
          field: 'changeDate',
          headerText: '변경 일자',
          textAlign: 'center',
          width: 100,
          type: 'string',
        },
        {
          field: 'insertDt',
          headerText: '등록 일자',
          textAlign: 'center',
          width: 100,
          type: 'string',
        },
        {
          field: 'insertName',
          headerText: '등록자',
          textAlign: 'center',
          width: 50,
          type: 'number',
        },
        {
          field: 'updateDt',
          headerText: '수정 일자',
          width: 100,
          textAlign: 'center',
          type: 'string',
        },
        {
          field: 'updateName',
          headerText: '수정자',
          width: 50,
          type: 'string',
        },
      ],
      pageSettings: {pageSize: 50}
    };
  },
  methods: {
    async fetchHomePagePasswordChangeHist() {
      let params = {
        fromDate: this.search.dateRange.from,
        toDate: this.search.dateRange.to,
        userName: this.search.userName
      };
      
      await GolfErpAPI.getHomePagePasswordChangeHist(params).then(res => {
        if (res) {

          res.forEach(e => {
            e.changeDate = moment(e.changeDate).format('YYYY-MM-DD');
          });

          this.content.HomePagePasswordChangeHist = res;
        }

        console.log(this.content.HomePagePasswordChangeHist);
      });
    },
    onPrintClick() {
    
      const result = this.$refs.grid.getGridBatchData();
      console.log(
        ' result==>', result
      );

      if (result.length < 1) {
        console.log('nodata');
        return this.errorToast(this.$t('report.popupMessage.noData'));
      }

      const searchOptionsList = [
        {
          key : '사용자',
          value : this.search.userName
        },
        {
          key: '조회일자',
          value: `${this.search.dateRange.from} ~ ${this.search.dateRange.to}`
        }
      ];

      const searchOptions = searchOptionsList
          .filter(item => !!item.value)
          .map(item => item.key + ': ' + item.value)
          .join(', ');

      const reportData = {
        reportJson: {
          jsonData: result,
          username: this.search.userName,
          uniqueCode: this.$options.name,
          searchOptions,
        },
      };
      console.log(JSON.stringify(reportData.reportJson));   
      this.$refs.reportViewComponent.postReport(reportData, this.$options.name);
    }
    ,
    gridComplete() {
      this.count = numberWithCommas(
        this.$refs.grid?.getGridBatchCount() || 0
      );
    },
    onExcelClick() {
      this.$refs.grid.excelExport();
    },
  },

};
</script>

<style scoped>

</style>